module.exports = __webpack_public_path__ + "img/menu5.f1fc3113.png";